import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    UpdateMapSpaceMutation,
    UpdateMapSpaceMutationVariables,
    UpdateMapSpaceInput,
    DeleteMapItemMutation,
    DeleteMapItemMutationVariables,
    UpdateMapItemMutation,
    UpdateMapItemMutationVariables,
    UpdateMapItem,
    CreateMapItemMutation,
    CreateMapItemMutationVariables,
    CreateMapItem
} from 'generated/graphql'

const updateMapSpaceMutation = gql`
    mutation updateMapSpace($id: ID!, $data: UpdateMapSpaceInput!) {
        updateMapSpace(id: $id, data: $data) {
            id
            parent {
                image
            }
        }
    }
`

export const updateMapSpace = (id, data: UpdateMapSpaceInput) => {
    const mutation = graphql.createQuery<
        UpdateMapSpaceMutation,
        UpdateMapSpaceMutationVariables
    >(updateMapSpaceMutation)

    return mutation({ id, data })
}

const updateMapItemMutation = gql`
    mutation updateMapItem($id: ID!, $data: UpdateMapItem!) {
        updateMapItem(id: $id, data: $data) {
            id
        }
    }
`
export const updateMapItem = (id, data: UpdateMapItem) => {
    const mutation = graphql.createQuery<
        UpdateMapItemMutation, UpdateMapItemMutationVariables
    >(updateMapItemMutation)
    return mutation({ id, data })
}

const deleteMapItemMutation = gql`
    mutation deleteMapItem($id: ID!) {
        deleteMapItem(id: $id)
    }
`
export const deleteMapItem = (id) => {
    const mutation = graphql.createQuery<
        DeleteMapItemMutation, DeleteMapItemMutationVariables
    >(deleteMapItemMutation)
    return mutation({ id })
}

const createMapItemMutation = gql`
    mutation createMapItem($data: CreateMapItem!) {
        createMapItem(data: $data) {
            id
        }
    } 
`
export const createMapItem = (data: CreateMapItem) => {
    const mutation = graphql.createQuery<
        CreateMapItemMutation, CreateMapItemMutationVariables
    >(createMapItemMutation)
    return mutation({ data })
}
